var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-head"},[_c('div',{staticClass:"has-full flex"},[_c('span',[_vm._v("付款方式")]),_c('img',{attrs:{"src":"/images/icons/icon-megaphone-orange.svg"}}),_c('div',{staticClass:"slider marquee"},[_c('BaseMarquee')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }